import { Component, OnInit } from '@angular/core';
import { AdminServiceService } from 'src/app/services/admin-service.service';
import { IpvService } from 'src/app/services/ipv.service';

@Component({
  selector: 'app-view-ipv-type',
  templateUrl: './view-ipv-type.component.html',
  styles: [
  ]
})
export class ViewIpvTypeComponent implements OnInit {


  public factors=[];
  constructor(private ipvService:IpvService, private adminService:AdminServiceService) {
    this.ipvService.getFactors().subscribe(
      resp=>{
        this.factors = resp;
      },
      err=>{
        console.log(err);
      }
    )

   }

   

  ngOnInit(): void {
  }

  handleDelete(factor){
    var opc = confirm("¿Eliminar factor?");
    if (opc){

      this.adminService.deleteFactor('ipv',factor._id).subscribe(
        resp=>{
          window.location.reload()
        },
        err=>console.log(err)
      )
    }

  }

}
